import { Component, OnInit } from '@angular/core';
import { SEOService } from '../services/seo.service';

@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.scss']
})
export class PartnerComponent implements OnInit {
  constructor(private seo: SEOService) {}

  pageTitle = "I nostri Partner | Leone Lifestyle";
  desc = "I Professionisti della salute e del benessere dove trovi la massima competenza per protocolli dietetici chetogenici, wellness e antiage in collaborazione diretta con il dottor Riccardo Ferrero Leone";
  shareImg = "partner/masthead-partner.jpg";

  ngOnInit() { 
    this.seo.updatePageTags(this.pageTitle, this.desc, this.shareImg);
  }

  //PARTNERS
  partners = [
    // {
    //   //BARI
    //   img: "partner-bari-mybeautycenter.jpg",
    //   city: "BARI",
    //   name: "MyBeauty Center",
    //   address_1: "Viale Einaudi 72, 70100 Bari",
    //   phone: "(+39) 080 975 25 12",
    //   web: "www.mybeautycenter.it"
    // },

    {
      img: "partner-bari-beautique.jpg",
      city: "BARI",
      name: "Beautique",
      address_1: "Via Melo 120, 70100 Bari",
      phone: "(+39) 080 524 45 76",
      web: "www.beautique.bio"
    },

    // {
    //   //BARLETTA-ANDRIA-TRANI
    //   img: "partner-barletta-carbone.jpg",
    //   city: "BARLETTA-ANDRIA-TRANI",
    //   name: "Dott.ssa Rosa Carbone - Biologa Nutrizionista",
    //   address_1: "Via della Repubblica 37, Minervino Murge (Barletta-Andria-Trani)",
    //   phone: "(+39) 370 12 68 503",
    //   mail: "nutrizionista89@gmail.com",
    //   mail_1: "rosa.carbone2@biologo.onb.it",
    //   social_1: "www.facebook.com/dott.ssaRosaCarbone",
    //   insta: "instagram.com/dott.rosa_carbone"
    // },

    {
      //BRESCIA
      img: "partner-brescia-cremaschi.jpg",
      city: "BRESCIA",
      name: "Farmacia Cremaschi",
      address_1: "Via Zanardelli 3, 25084 - Gargnano (Brescia)",
      phone: "(+39) 0365 71 380",
      web: "www.farmaciacremaschi.it",
      social_1: "www.facebook.com/farmaciacremaschigargnano"
    },

    {
      //BRINDISI
      img: "partner-brindisi-2.0.jpg",
      city: "BRINDISI",
      name: "ParaFarmacia 2.0 Dott.ssa Torsello",
      address_1: "Via Tagliamento 72/B, 72028 - Torre Santa Susanna (Brindisi)",
      phone: "(+39) 0831 746 800",
      web: "www.parafarmaciatorsello.it"
    },

    // {
    //   //CATANIA
    //   img: "partner-catania-coppolino.jpg",
    //   city: "CATANIA",
    //   name: "Parafarmacia Dott.ssa V. Coppolino",
    //   address_1: "Piazza Duca di Camastra 4, 95126 - Catania",
    //   phone: "(+39) 348 69 95 363",
    //   phone_2: "(+39) 375 50 34 953",
    //   social_1: "www.facebook.com/parafarmaciacoppolino"
    // },

    {
      //CATANIA
      img: "partner-catania-statelli.jpg",
      city: "CATANIA",
      name: "Dott.ssa Dorotea Statelli - Consulente nutrizionale",
      address_1: "Via delle Rose 14, 95047 Paternò (Catania)",
      phone: "(+39) 345 40 60 915"
    },

    {
      //NOVARA
      img: "partner-novara.jpg",
      city: "NOVARA",
      name: "Dott. Raffaele Picco - Dottore in Scienza della Nutrizione Umana, Farmacista, Formazione in Dieta Chetogenica, Nutrizione del paziente oncologico, Nutrizione in gravidanza e allattamento",
      address_1: "Via del Basso 1, 28068 - Romentino (Novara)",
      phone: "(+39) 347 48 32 405"
    },

    {
      //PALERMO
      img: "partner-palermo-marabeti.jpg",
      city: "PALERMO",
      name: "Maria Rita Dott.ssa Marabeti - Biologo Nutrizionista",
      address_1: "Largo Montalto 7, 90144 - Palermo",
      address_2: "Via SP 57 n. 80 - 90046 Monreale (Palermo)",
      phone: "(+39) 320 81 94 614"
    },

    {
      //PESARO
      img: "partner-pesaro.jpg",
      city: "PESARO",
      name: "MY20 - Nutrizione - Fitness - Estetica",
      address_1: "Via del Carso 20, 61121 - Pesaro",
      phone: "(+39) 0721 58 54 78",
      web: "www.my20.it",
      mail: "info@my20.it"
    },

    {
      //PISA
      img: "partner-pisa-norpoth.jpg",
      city: "PISA",
      name: "Dott.ssa Maria Norpoth - Medico Chirurgo Specialista in Nefrologia - Responsabile dell'ambulatorio diabetologico AVC (alta Val di Cecina) - Master in nutrizione e dietologia",
      address_1: "Ospedale Santa Maria Maddalena, Borgo San Lazzero 5,  Volterra - Poliambulatorio",
      phone: "(+39) 0587 09 88 30",
      phone_2: "(+39) 0588 91 835 (solo martedì mattina)",
      info: "Prenotazione per VISITA DIABETOLOGICA tramite CUP "
    },

    // {
    //   //RICCIONE
    //   img: "partner-riccione.jpg",
    //   city: "RICCIONE",
    //   name: "Studio Mirella - Naturopatia - Riflessologia - Massaggi - Nutrizione",
    //   address_1: "Viale Veneto 248, 47838 - Case del Molino (Riccione)",
    //   phone: "(+39) 328 82 16 853",
    //   social_1: "www.facebook.com/mirellabenessere"
    // },

    {
      //ROMA
      img: "partner-roma-pantheon.jpg",
      city: "ROMA",
      name: "Parafarmacia del Pantheon",
      address_1: "Via Santa Caterina da Siena 48, 00184 - Roma",
      phone: "(+39) 06 877 88 064"
    },

    {
      img: "partner-roma-loiacono.jpg",
      name: "Dott.ssa Silvia Lo Iacono - Biologa Nutrizionista - Farmacista",
      address_1: "Via di S. Anselmo, 38, 00153 - Roma",
      phone: "(+39) 393 89 23 013",
      web: "www.dietaventino.com"
    },

    {
      img: "partner-roma-bombardi.jpg",
      name: "Dott.ssa Eleonora Bombardi - Biologa Nutrizionista",
      address_1: "Viale Trastevere 6, 00153 - Roma",
      phone: "(+39) 333 90 55 016",
      mail: "nutrizione.eb@gmail.com"
    },

    {
      img: "partner-roma.jpg",
      name: "Farmacia Iampiconi",
      address_1: "Via Reatina 48/A, 00013 - Mentana (Roma)",
      phone: "(+39) 06 909 1455",
      web: "www.farmaciaiampiconi.com"
    },

    {
      img: "partner-roma.jpg",
      name: "Parafarmacia Dott.ssa Tatiana Marcellitti",
      address_1: "Via Ermanno Wolf Ferrari 230, 00124 - Roma Infernetto",
      phone: "(+39) 06 645 31 587",
      social_1: "www.facebook.com/tatiana.marcellitti"
    },

    // {
    //   img: "partner-roma.jpg",
    //   name: "Centro benessere Estetica Maxximo",
    //   address_1: "Via Monterotondo 27/a, 00199 - Roma",
    //   phone: "(+39) 06 862 17 280"
    // },

    // {
    //   img: "partner-roma-crepanti.jpg",
    //   name: "Dott.ssa Ilaria Screpanti - Dietista",
    //   address_1: "Via di Dragone, 317 Roma Dragona",
    //   address_2: "Via Giuseppe Partini 35, 00169 Roma Cinecittà",
    //   phone: "(+39) 348 80 82 345",
    //   mail: "ilaria.screpanti@hotmail.it"
    // },

    {
      img: "partner-roma.jpg",
      name: "Farmacia San Pio",
      address_1: "Via Santa Bernadette 55, 00167 - Roma",
      phone: "(+39) 06 662 94 40"
    },

    {
      img: "partner-roma-borraccino.jpg",
      name: "Dott.ssa Caterina Borraccino - Biologa Nutrizionista",
      address_1: "Via Ermanno Wolf Ferrari 230, 00124 - Roma",
      phone: "(+39) 351 646 85 39",
      mail: "borraccino.nutrizione@gmail.com",
      web: "www.caterinaborraccino.it",
      social_1: "www.facebook.com/benesserepaleo",
      social_2: "www.facebook.com/groups/838488122929011",
      social_3: "www.facebook.com/catbor",
      insta: "www.instagram.com/caterina.borraccino"
    },

    {
      img: "partner-roma-pizzico.jpg",
      name: "Dott.ssa Tiziana Pizzico - Riequilibrio emozionale E.F.T. - Mindfulness - Naturopatia",
      phone: "(+39) 347 336 00 80",
      mail: "tizianapizzico@gmail.com"
    },

    {
      //SONDRIO
      img: "partner-sondrio-testa.jpg",
      city: "SONDRIO",
      name: "Evelin Testa - Infermiera specializzata in nutrizione clinica e nutraceutica",
      address_1: "Via Nazionale Est 377, 23010 - Berbenno di Valtellina (Sondrio)",
      phone: "(+39) 328 47 50 238"
    },

    {
      //TARANTO
      img: "partner-taranto-crazybeauty.jpg",
      city: "TARANTO",
      name: "Crazy Beauty & Spa",
      address_1: "Via Lago Trasimeno 2/1, 74121 - Taranto",
      phone: "(+39) 099 772 93 13",
      phone_2: "(+39) 366 326 31 48",
      social_1: "www.facebook.com/CRAZYBEAUTYSPA",
      mail: "crazybeautyspa@gmail.com"
    },

    {
      //TERNI
      img: "partner-terni-manfroi.jpg",
      city: "TERNI",
      name: "Dott.ssa Elisabetta Manfroi - Laurea in Scienze Biologiche - Specialista in Genetica Medica Biologo Nutrizionista c/o Salvati Diagnostica- Poliambulatorio",
      address_1: "P.zza del Mercato 61, 05100 - Terni",
      phone: "(+39) 392 839 43 60"
    },

    {
      //TORINO
      img: "partner-torino-diamondbeauty.jpg",
      city: "TORINO",
      name: "Diamond Beauty Centro Dimagrimento & Modellamento Corpo",
      address_1: "Piazza Montanari 131/G, 10137 - Torino",
      phone: "(+39) 011 305 34 13",
      social_1: "www.facebook.com/DiamondBeautyDimagrimento"
    }/*,

    {
      // VENEZIA
      img: "partner-venezia-arina.jpg",
      city: "VENEZIA",
      name: "Dott.ssa Giorgia A. Arina - Operatore Naturopata - Health Coach Ketogenic Diet",
      address_1: "Via G.Carducci 13, 30171 - Venezia",
      phone: "(+39) 340 461 82 78",
      web: "www.ketonutrizione.com",
      mail: "ketonutrizione@gmail.com",
      insta: "www.instagram.com/ketonutrizione"
    }*/
  ]
}
